import { render, staticRenderFns } from "./StaffRequests.vue?vue&type=template&id=39c119c7&"
import script from "./StaffRequests.vue?vue&type=script&lang=js&"
export * from "./StaffRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports